export class TimerData {
  /** @type number */
  incrementFactor
  /** @type number */
  initialValue
  /** @type number */
  limitTime
  /** @type Function */
  timeOffHandler
  /** @type number */
  frequency

  /**
   *
   * @param {{
   * incrementFactor: number,
   * initialValue: number,
   * limitTime: number,
   * timeOffHandler: Function,
   * frequency: number,
   * }} data
   */
  constructor(data) {
    this.incrementFactor = data.incrementFactor
    this.initialValue = data.initialValue
    this.limitTime = data.limitTime
    this.timeOffHandler = data.timeOffHandler
    this.frequency = data.frequency
  }
}
